export const queryPlatform = groq`*[_type == "product" && currentPathname == $currentPathname][0]`;
